import { render } from "./ImmunizationModal.vue?vue&type=template&id=43c55480&scoped=true"
import script from "./ImmunizationModal.vue?vue&type=script&lang=js"
export * from "./ImmunizationModal.vue?vue&type=script&lang=js"

import "./ImmunizationModal.vue?vue&type=style&index=0&id=43c55480&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43c55480"]])

export default __exports__